module.exports = __webpack_public_path__ + "static/media/wheel_person.424cc4d1.png";